module.exports = __webpack_public_path__ + "766913e6c0088ab8c9f73e18b4127bc4.ttf";